import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const WatchlistContext = createContext({ companies: new Set(), toggle: () => {}, isWatched: () => false, refresh: () => {} });

export const useWatchlist = () => useContext(WatchlistContext);

export const WatchlistProvider = ({ children }) => {
  const [companies, setCompanies] = useState(new Set());

  const fetchWatchlist = useCallback(async () => {
    const token = localStorage.getItem('backoffice_token');
    if (!token) return;
    try {
      const res = await fetch(`${API_URL}/api/intelligence/watchlist/check`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setCompanies(new Set(data.companies || []));
      }
    } catch {}
  }, []);

  useEffect(() => { fetchWatchlist(); }, [fetchWatchlist]);

  const toggle = useCallback(async (company, sourceModule = '') => {
    const token = localStorage.getItem('backoffice_token');
    if (!token) return;
    const isCurrentlyWatched = companies.has(company);
    try {
      if (isCurrentlyWatched) {
        const res = await fetch(`${API_URL}/api/intelligence/watchlist/${encodeURIComponent(company)}`, {
          method: 'DELETE',
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          setCompanies(prev => { const n = new Set(prev); n.delete(company); return n; });
        }
      } else {
        const res = await fetch(`${API_URL}/api/intelligence/watchlist`, {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify({ company, source_module: sourceModule }),
        });
        if (res.ok) {
          setCompanies(prev => new Set([...prev, company]));
        }
      }
    } catch {}
  }, [companies]);

  const isWatched = useCallback((company) => companies.has(company), [companies]);

  return (
    <WatchlistContext.Provider value={{ companies, toggle, isWatched, refresh: fetchWatchlist }}>
      {children}
    </WatchlistContext.Provider>
  );
};
